const commonConstants = {
  COMMON_CHANGE_LOCATION:   'COMMON_CHANGE_LOCATION',
  COMMON_GET_PAGES_FAILURE: 'COMMON_GET_PAGES_FAILURE',
  COMMON_GET_PAGES_REQUEST: 'COMMON_GET_PAGES_REQUEST',
  COMMON_GET_PAGES_SUCCESS: 'COMMON_GET_PAGES_SUCCESS',
  COMMON_GET_PAGE_FAILURE:  'COMMON_GET_PAGE_FAILURE',
  COMMON_GET_PAGE_REQUEST:  'COMMON_GET_PAGE_REQUEST',
  COMMON_GET_PAGE_SUCCESS:  'COMMON_GET_PAGE_SUCCESS',
};

export default commonConstants;